export default function getLocale(state) {
  return state.intl.locale;
}